"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "HelpCircle___StyledSvg",
  componentId: "sc-2o7wxv-0"
})(["color:", ";width:", ";height:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
});

function HelpCircle(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 480 480",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M261 279.354V303h-42v-63h21c23.163 0 42-18.837 42-42 0-23.184-18.837-42-42-42s-42 18.816-42 42h-42c0-46.326 37.674-84 84-84s84 37.674 84 84c0 39.06-26.817 71.988-63 81.354m-21 91.896c-14.49 0-26.25-11.76-26.25-26.25s11.76-26.25 26.25-26.25 26.25 11.76 26.25 26.25-11.76 26.25-26.25 26.25M240 30C124.206 30 30 124.206 30 240c0 115.815 94.206 210 210 210s210-94.185 210-210c0-115.794-94.206-210-210-210"
  }));
}

var _default = HelpCircle;
exports["default"] = _default;